import { useEffect, useState } from 'react';

/**
 * Debounce a value so rapid changes (e.g. typing) settle before consumers react.
 */
export default function useDebounce(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
